import AddSupplier from './AddSupplier';

export default AddSupplier;